export class Employee {
    id!: number;
    created_at!: Date;
    updated_at!: Date;
    created_by_id!: number;
    updated_by_id!: number;
    first_name!: string;
    middle_name!: string;
    last_name!: string;
    email!: string;
    mobile_phone!: string;
    secondary_phone!: string;
    birth_date!: string;
    birth_place!: string;
    nationality!: string;
    national_id!: string;
    foreign_id!: string;
    street_address!: string;
    apartment!: string;
    city!: string;
    district!: string;
    postal_code!: string;
    notes!: string;
    account_number!: string;
    bic!: string;    
    areas!: object;
    assignments!: object;
    employee_groups!: object;
    disable_reserving!: boolean;
    skills!: any;
    rating!: number;
    ratings!: number;
    picture!: string;
    referral_code!: string;
}
